"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={disableHoverListener:!0,disableTouchListener:!0};exports.keyboardOnlyTooltipProps=e;
//# sourceMappingURL=keyboardOnly.js.map
